import { useGeomBinDispatch } from "components/geom-bin/hooks/useGeomBinDispatch";

import { FlexItem, LayerActionsWrapper, LeafTitle } from "../../../../shared";
import { GeomBinActions } from "../../../../shared/geom-bin-actions/GeomBinActions";

export interface IPolygonBinNode {
  node: {
    key: string;
    title: string;
    projectId?: string;
    source?: string;
  };
}

export function PolygonBinNode({ node }: IPolygonBinNode) {
  const geomBinDispatch = useGeomBinDispatch();
  const editGeomBin = () => {
    geomBinDispatch({
      payload: {
        isActive: true,
        isLoading: true,
        selectedGeomBinId: node.key,
        isOrg: node?.source === "org",
        projectId: node?.projectId
      }
    });
  };

  return (
    <LeafTitle>
      <FlexItem>
        <label>{node.title}</label>
      </FlexItem>
      <FlexItem>
        <LayerActionsWrapper>
          <GeomBinActions editGeomBin={editGeomBin} />
        </LayerActionsWrapper>
      </FlexItem>
    </LeafTitle>
  );
}
